import React from 'react';
import { Users2 } from 'lucide-react';

const PartnersSection: React.FC = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-4 text-primary-900">
            Investment Partners
          </h2>
          <p className="text-gray-600">
            We proudly work with trusted organisations including:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center">
            <img src="https://storage.googleapis.com/msgsndr/Lqis7QfI2CPng4DTN4vN/media/6812046a4d0d3d44478d9dee.png" alt="Equa Academy" className="h-12 opacity-70 hover:opacity-100 transition-opacity" />
          </div>
          <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center">
            <img src="https://storage.googleapis.com/msgsndr/Lqis7QfI2CPng4DTN4vN/media/6812046a4d0d3d5d9f8d9ded.png" alt="Empowered Group" className="h-12 opacity-70 hover:opacity-100 transition-opacity" />
          </div>
          <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center">
            <img src="https://storage.googleapis.com/msgsndr/Lqis7QfI2CPng4DTN4vN/media/6812046aa00f640368f97677.png" alt="Nimbus" className="h-12 opacity-70 hover:opacity-100 transition-opacity" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto mt-8">
          <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center">
            <img src="https://storage.googleapis.com/msgsndr/Lqis7QfI2CPng4DTN4vN/media/6812046a33fee4fb9b4984dc.png" alt="GMS" className="h-12 opacity-70 hover:opacity-100 transition-opacity" />
          </div>
          <div className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center">
            <img src="https://storage.googleapis.com/msgsndr/ap2Q41Z69uKBs4zBH2l0/media/6821dbb7eca753d9205c05b0.svg" alt="Investment Partner" className="h-12 opacity-70 hover:opacity-100 transition-opacity" />
          </div>
        </div>

        <div className="max-w-3xl mx-auto text-center mt-12">
          <p className="text-gray-600">
            Our network gives us access to the latest market intelligence, property insights, and off-market opportunities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;